import { useState } from 'react';

import { outcomeLabel } from './pendencies-adapter';

import type { PendencyResolutionOutcome, PendencyWireItem } from '../../lib/api-client';
import type { JSX } from 'react';

const OUTCOMES: PendencyResolutionOutcome[] = [
  'success',
  'with_restrictions',
  'not_possible',
  'customer_gave_up',
  'replaced',
  'other',
];

/**
 * ResolvePendencyModal — resolve a pendência com desfecho canônico (ADR-109
 * Brief 2B B1, 6 valores) + nota opcional. Idioma de modal do atendente.
 */
export function ResolvePendencyModal({
  open,
  pendency,
  submitting,
  onClose,
  onConfirm,
}: {
  open: boolean;
  pendency: PendencyWireItem;
  submitting: boolean;
  onClose: () => void;
  onConfirm: (p: { outcome: PendencyResolutionOutcome; resolutionNote?: string }) => void;
}): JSX.Element | null {
  const [outcome, setOutcome] = useState<PendencyResolutionOutcome>('success');
  const [note, setNote] = useState('');

  if (!open) return null;

  const handleConfirm = (): void => {
    const trimmed = note.trim();
    onConfirm(trimmed.length > 0 ? { outcome, resolutionNote: trimmed } : { outcome });
  };

  return (
    <div
      role="dialog"
      aria-label="Resolver pendência"
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4"
    >
      <div
        className="w-full max-w-lg rounded-lg p-6 shadow-xl"
        style={{ background: 'var(--bg-surface)' }}
      >
        <h2 className="mb-1 text-lg font-semibold">Resolver pendência</h2>
        <p className="mb-4 text-sm" style={{ color: 'var(--fg-3)' }}>
          {pendency.title}
        </p>

        <div className="mb-3">
          <span className="mb-1 block text-sm font-medium">Desfecho</span>
          <div className="flex flex-wrap gap-2">
            {OUTCOMES.map((o) => (
              <button
                key={o}
                type="button"
                className={`btn btn--sm ${outcome === o ? 'btn--primary' : 'btn--secondary'}`}
                onClick={() => setOutcome(o)}
              >
                {outcomeLabel(o)}
              </button>
            ))}
          </div>
        </div>

        <label className="mb-3 block">
          <span className="mb-1 block text-sm font-medium">Nota de resolução (opcional)</span>
          <textarea
            className="w-full rounded border px-2 py-1"
            style={{ background: 'var(--bg-surface-2)', borderColor: 'var(--border-default)' }}
            rows={3}
            maxLength={2000}
            value={note}
            onChange={(e) => setNote(e.target.value)}
            placeholder="Ex.: cliente enviou o comprovante por WhatsApp e confirmou os dados."
          />
        </label>

        <div className="mt-4 flex justify-end gap-2">
          <button
            type="button"
            className="rounded border px-4 py-2 text-sm"
            style={{ borderColor: 'var(--border-default)' }}
            onClick={onClose}
            disabled={submitting}
          >
            Cancelar
          </button>
          <button
            type="button"
            className="btn btn--primary"
            onClick={handleConfirm}
            disabled={submitting}
          >
            {submitting ? 'Resolvendo…' : 'Confirmar resolução'}
          </button>
        </div>
      </div>
    </div>
  );
}
